import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChange,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import {IRoleModel, TaskModel, UserTasksSettings} from '../../models/task.model';
import {MemberModel} from '../../models/user.model';
import {HelpersService} from '../../services/helpers.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MemberService} from '../../services/member.service';
import {PaginationModel} from '../../models/file-table.model';
import {TaskServiceService} from '../../services/task-service.service';
import {CrmService} from '../../services/api/crm.service';
import {AlertService} from '../../services/notify/alert.service';
import {ModalService} from '../../services/modal/modal.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {BoardGroupModel, BoardTableModel, NodeSettingsModel, TaskBoardModel} from '../../models/tasktable.model';
import {TranslateService} from '@ngx-translate/core';

// import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-component-tasks-table',
    templateUrl: './tasks-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./tasks-table.component.scss'],
})

export class TasksTableComponent implements OnInit, OnChanges {
    @Input() tasks: TaskModel[];
    @Input() range: any;
    @Input() public personGuid: string;
    /** события по сортировке или пагинации */
    @Input() public $pagination: EventEmitter<PaginationModel> = new EventEmitter();
    /** переходить на страницу задачи */
    @Input() public isNavigate = true;
    @Input() public searchType: string;
    @Input() public emitSaveSettings: EventEmitter<any> = new EventEmitter<any>();
    @Input() isSubtasks = false;
    @Input() parentTaskAlias: string;
    @Input() public emitReload: EventEmitter<any> = new EventEmitter<any>();
    @Input() subtasks: TaskModel[];
    @Input() public isMini: boolean;
    @Input() colons: UserTasksSettings[] = [];
    @Input() boardAlias: string;

    @Output() public emitEventSelected: EventEmitter<TaskModel> = new EventEmitter<TaskModel>();
    @Output() public eventSubmit: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public eventSubtaskReload: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('viewTaskView') public viewTaskView: TemplateRef<any>;
    public currentMember: MemberModel;
    initialTasks: TaskModel[] = [];
    selectTask: TaskModel = null;
    loading = true;
    sort: SimpleChange;
    public pagination: PaginationModel = {
        limit: 50,
        current_page: 1,
        role: 'author,responsible,executor,observer,observer_contract',
        board_statuses: '',
        board_alias: '',
        contract_is_empty: false,
    };
    selectedBoard: any;
    alias: string;
    filter = {
        roles: [
            {
                isSelected: true,
                value: 'author',
            },
            {
                isSelected: true,
                value: 'executor',
            },
            {
                isSelected: true,
                value: 'observer',
            },
            {
                isSelected: true,
                value: 'responsible',
            },
            {
                isSelected: true,
                value: 'observer_contract',
            },
        ],
        more: false,
    };

    allBoardsForFilter: BoardTableModel[] = [];
    selectedBoardForFilter: TaskBoardModel;
    isFilterUsed = false;
    selectedStatusesIds: number[] = [];
    boardRangeIndex: number[];
    propertyIcon: {
        [key: string]: {
            icon: string,
            tooltip: string
        }
    } = {
        property_file: {
            icon: 'bi bi-file-earmark-word prop_icon',
            tooltip: 'DOCUMENT',
        },
        property_member: {
            icon: 'bi bi-person prop_icon',
            tooltip: 'MEMBER',
        },
        property_text: {
            icon: 'bbi bi-card-text prop_icon',
            tooltip: 'TEXT',
        },
        property_boolean: {
            icon: 'bi bi-check2-circle prop_icon',
            tooltip: 'BOOLEAN',
        },
        property_catalog: {
            icon: 'bi bi-justify prop_icon',
            tooltip: 'CATALOG',
        },
        property_todo: {
            icon: 'bi bi-clipboard2-check prop_icon',
            tooltip: 'TODO',
        },
    };
    membersComplete = false;
    @ViewChild('filterContainer') private filterContainer: ElementRef;
    @ViewChild('filterButtonShowContainer') private filterButtonShowContainer: ElementRef;

    constructor(
        protected router: Router,
        protected memberService: MemberService,
        public helper: HelpersService,
        public routing: ActivatedRoute,
        public taskService: TaskServiceService,
        public crmService: CrmService,
        public alert: AlertService,
        private modalService: ModalService,
        public translate: TranslateService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
        this.selectTask = null;
        this.memberService.getCurrentMember().then(data => {
            this.currentMember = data;
        });
    }

    @HostListener('document:click', ['$event'])
    AfterClick(event: MouseEvent): void {
        const clickTarget = event.target;

        if (this.filterButtonShowContainer && this.filterButtonShowContainer.nativeElement.contains(event.target)) {
            this.openFilter();
        }
        if (this.filterContainer && !this.filterContainer.nativeElement.contains(clickTarget)) {
            this.filter.more = false;
        }
    }

    ngOnInit(): void {
        this.pagination.sort_by = 'created_at';
        this.pagination.sort = 'desc';
        this.emitSaveSettings.subscribe(reload => {
            if (reload) {
                void this.loadTasks(!!this.alias, true);
            }
        });
        if (!this.isSubtasks) {
            this.emitReload.subscribe(reload => {
                if (reload) {
                    void this.loadTasks(!!this.alias, true);
                }
            });

            this.routing.params.subscribe(res => {
                this.alias = res.alias;
                this.taskService.getBoard(this.alias ? this.alias : null).then(res2 => {
                    this.selectedBoard = res2;
                    void this.loadTasks(!!this.alias, true);
                });
            });
        } else {
            this.loading = false;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.range) {
            this.sort = changes.range;
            if (changes.range.currentValue && (changes.range.previousValue && !changes.range.previousValue[1])) {
                this.tasks = this.tasks.filter(x =>
                    this.helper.dateFromFormat(x.deadline_at) >= changes.range.currentValue[0] || !x.deadline_at);
                if (changes.range.currentValue[1]) {
                    this.tasks = this.tasks.filter(x =>
                        this.helper.dateFromFormat(x.deadline_at) <= changes.range.currentValue[1] || !x.deadline_at);
                }
            } else if (this.selectedBoard && !this.isSubtasks) {
                void this.loadTasks(true);
            }
        }
    }

    trackByAlias(index: number, item: TaskModel) {
        return item.task_alias;
    }

    trackByKey(index: number, item: UserTasksSettings): string {
        return item.alias;
    }

    changeTask(task: TaskModel, dblclick = false): void {
        if (this.selectTask && this.selectTask.task_alias === task.task_alias && !dblclick) {
            return this.selectTask = undefined;
        } else {
            this.selectTask = task;
        }
        this.emitEventSelected.emit(task);

        if (this.isNavigate && dblclick) {
            if (this.alias) {
                void this.router.navigate(['account', 'tasks', this.searchType, this.alias, task.task_alias]);
            } else {
                if (this.searchType) {
                    void this.router.navigate(['account', 'tasks', this.searchType, task.task_alias]);
                } else {
                    this.modalService.openTemplateModal(this.viewTaskView, 'xl');
                }
            }
        } else if (dblclick) {
            this.modalService.openTemplateModal(this.viewTaskView, 'xl');
        }
    }

    async loadTasks(isBoard: boolean = false, refresh = false): Promise<any> {
        if (this.isSubtasks) {
            return this.eventSubtaskReload.emit();
        }
        this.loading = true;
        this.initialTasks = [];
        this.tasks = null;
        if (!isBoard && !this.parentTaskAlias) {
            if (this.currentMember) {
                this.loadMembersTask(refresh);
            } else {
                this.memberService.getCurrentMember().then(data => {
                    this.currentMember = data;
                    this.loadMembersTask(refresh);
                });
            }
        } else {
            const aliasUrl = window.location.pathname.split('/').reverse()[0].split('-')[0];
            this.taskService.getTasks(
                this.selectedBoard ? this.selectedBoard.board : {alias: aliasUrl},
                this.pagination,
                refresh
            ).then(res => {
                this.loading = false;
                this.tasks = res.tasks;
                this.colons = res.colons;
                this.boardRangeIndex = res.importance_indexes;
                this.getTaskMembers();
                if (this.sort && this.sort.firstChange && this.sort.currentValue) {
                    this.tasks = this.tasks.filter(x =>
                        this.helper.dateFromFormat(x.deadline_at) >= this.sort.currentValue[0] || !x.deadline_at);
                    if (this.sort.currentValue[1]) {
                        this.tasks = this.tasks.filter(x =>
                            this.helper.dateFromFormat(x.deadline_at) <= this.sort.currentValue[1] || !x.deadline_at);
                    }
                } else {
                    if (this.subtasks) {
                        for (const task of this.subtasks) {
                            this.tasks = this.tasks.filter(x => x.task_alias !== task.task_alias
                                && this.parentTaskAlias !== task.task_alias);
                        }
                    }
                    if (this.parentTaskAlias) {
                        this.tasks = this.tasks.filter(x => this.parentTaskAlias !== x.task_alias);
                    }
                    this.initialTasks = structuredClone(this.tasks);
                }
            });
        }
    }

    loadMembersTask(refresh = false): void {
        this.loading = true;
        let guid: string;
        if (!this.personGuid) {
            if (this.searchType === 'my' && this.currentMember && this.isNavigate) {
                guid = this.currentMember.guid;
            } else {
                guid = '';
            }
        } else {
            guid = this.personGuid;
            this.pagination.board_alias = this.boardAlias ?? '';
        }

        if (!this.isNavigate) {
            this.pagination.contract_is_empty = true;
        }

        this.taskService.getTableTasks(guid, refresh, this.pagination).then(data => {
            this.pagination.pages = data.page_count ? data.page_count : 1;
            this.pagination.current_page = data.current_page;
            this.loading = false;
            this.initialTasks = data.data;
            this.tasks = data.data;
            this.colons = data.colons;
            this.membersComplete = false;
            this.getTaskMembers();
        }, () => {
            this.loading = false;
        });
    }

    getTaskMembers(): void {
        let membersGuids: string[] = [];
        this.tasks.forEach(task => {
            ['executor', 'responsible'].forEach((roleGuids: any) => {
                task.roles[roleGuids].forEach((roleMember: IRoleModel) => {
                    membersGuids.push(roleMember.user_guid);
                });
            });
        });
        this.memberService.memberGuidsHandler(membersGuids).then(members => {
            this.tasks = this.tasks.map(task => {
                ['executor', 'responsible'].forEach(roleKey => {
                    task.roles[roleKey] = task.roles[roleKey].map((userGuid: IRoleModel) => {
                        userGuid.memberModel = members.find(x => x.guid === userGuid.user_guid);
                        return userGuid;
                    });
                });
                return task;
            });
            this.membersComplete = true;

            this.changeDetectorRef.detectChanges();
        });
    }

    sortBy(column: string): void {
        if (['roles', 'user_roles', 'task_board_name', 'task_type'].includes(column)) {
            return;
        }
        let sort = 'desc';
        this.initialTasks = this.tasks;
        if (column === this.pagination.sort_by) {
            sort = this.pagination.sort === 'desc' ? 'asc' : 'desc';
        }
        const pagination: PaginationModel = this.pagination;
        pagination.sort_by = column;
        pagination.sort = sort;

        this.$pagination.emit(pagination);
        this.changePage(pagination.current_page);
    }

    getTrClass(item: TaskModel): string {
        const css = ['table-task-title'];
        switch (item.importance) {
            case 'NORMAL':
                css.push('table-light');
                break;
            case 'MIDDLE':
                css.push('table-warning');
                break;
            case 'IMPORTANT':
                css.push('table-danger');
                break;
        }

        return css.join(' ');
    }

    submitItem(): void {
        this.eventSubmit.emit();
    }

    changePage(page: number): void {
        this.membersComplete = false;
        this.pagination.current_page = page;
        void this.loadTasks(!!this.alias, true);
    }

    deleteTaskFormSubtasks(taskAlias: string): void {
        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_CHILD_TASK'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.crmService.deleteSubtask(this.parentTaskAlias, taskAlias).subscribe({
                    next: res => {
                        this.alert.setAlert(res.message, 'green');
                        this.eventSubtaskReload.emit();
                    }, error: error => {
                        this.alert.setAlert(error.message, 'blue');
                    },
                });
            }
        }).catch(() => {
            return;
        });
    }

    onChangeSort(sort: {
        isSelected: boolean;
    }): void {
        sort.isSelected = !sort.isSelected;
        const roles = [];

        for (const iAm in this.filter.roles) {
            if (this.filter.roles[iAm].isSelected) {
                roles.push(this.filter.roles[iAm].value);
            }
        }

        this.pagination.role = roles.toString();
        this.loadMembersTask(true);
    }

    taskWillBeDeleted(modal: NgbModalRef): void {
        this.eventSubtaskReload.emit();
        modal.close();
    }

    sortTasks(searchingText: string): void {
        this.loadTasks(true).then(() => {
            this.tasks = this.taskService.sortTasksBySearch(this.tasks, searchingText);
        });
    }

    openProfile(event: MouseEvent, user: MemberModel): void {
        event.preventDefault();
        event.stopPropagation();
        this.helper.openProfileByGuid(user.guid);
    }

    openBoard(event: MouseEvent, task: TaskModel): void {
        event.preventDefault();
        event.stopPropagation();
        if (this.isNavigate) {
            this.taskService.getBoard(task.task_alias.split('-')[0], true).then(() => {
                void this.router.navigate(['account', 'tasks', 'all', task.task_alias.split('-')[0]]);
            });
        }
    }

    // updateAfterDrag(e: CdkDragDrop<any>): void {
    //     if (e.previousIndex === e.currentIndex) {
    //         return;
    //     }
    //     const newIndex = this.tasks[e.currentIndex].importance_index;
    //     void this.editImportanceIndex(e.item.data, newIndex)
    // }

    editImportanceIndex(task: TaskModel, newIndex: number): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const data = {
                title: task.title,
                content: task.content,
                deadline_at: task.deadline_at ? task.deadline_at.substring(0, 10) : null,
                importance: task.importance,
                task_type_id: task.task_type.id,
                due_time: task.due_time ? task.due_time.replace(' ', 'T') + 'Z' : null,
                duration: task.duration ? task.duration : null,
                importance_index: newIndex,
            };

            this.crmService.editTask(task.task_alias, data).subscribe({
                next: res => {
                    this.alert.setAlert(res.message, 'green');
                    void this.loadTasks(!!this.alias, true);
                    resolve(true);
                }, error: err => {
                    reject(false);
                    this.alert.setAlert(err.message, 'blue');
                }
            });
        });
    }

    openFilter(): void {
        this.filter.more = !this.filter.more;

        this.taskService.getAllBoards(false).then(result => {
            this.allBoardsForFilter = result.boards;
            result.groups.map((x: BoardGroupModel) => {
                this.allBoardsForFilter = this.allBoardsForFilter.concat(x.boards);
            });
        });
    }

    getDetailBoardForFilter(board: BoardTableModel): void {
        if (this.selectedBoardForFilter && this.selectedBoardForFilter.alias === board.alias) {
            this.selectedBoardForFilter = null;
            if (this.selectedStatusesIds.length) {
                this.selectedStatusesIds = [];
            }
            return;
        } else {
            this.selectedStatusesIds = [];
        }
        this.crmService.getBoardByAlias(board.alias).subscribe({
            next: res => {
                this.selectedBoardForFilter = res.board;
            }
        });
    }

    checkStatusId(status: NodeSettingsModel, force = false): void {
        if (!this.selectedStatusesIds.includes(status.status_node.id)) {
            this.selectedStatusesIds.push(status.status_node.id);
        } else {
            this.selectedStatusesIds = this.selectedStatusesIds.filter(x => x !== status.status_node.id);
        }

        if (force) {
            this.refreshTasksWithSort();
        }
    }

    refreshTasksWithSort(): void {
        this.pagination.board_alias = this.selectedBoardForFilter.alias;
        this.pagination.board_statuses = this.selectedStatusesIds.toString();
        this.loadMembersTask(true);
        this.isFilterUsed = true;
        this.filter.more = false;
    }

    clearFilter(): void {
        this.pagination.board_alias = '';
        this.selectedBoardForFilter = null;
        this.pagination.board_statuses = '';
        this.selectedStatusesIds = [];
        this.loadMembersTask(true);
        this.filter.more = false;
        this.isFilterUsed = false;
    }
}
